module.exports = __webpack_public_path__ + "static/media/104paddleBall.7ff33f68.gif";